import { useCallback, useEffect } from "react";
import styles from "../../../pages/ordermanager/Orders.module.css";
import { CloseIcon } from "../../icons/Icon2";
import Button from "../Dealers/Button";

const ShippingTypeModal = ({
  mode = true,
  handleCloseModal,
  setShippingType,
  openShippingModal2,
}) => {
  const combinedClick = useCallback(() => {
    setShippingType("Combined");
    openShippingModal2("Combined");
  }, [openShippingModal2, setShippingType]);

  const separateClick = useCallback(() => {
    setShippingType("Separate");
    openShippingModal2("Separate");
  }, [openShippingModal2, setShippingType]);

  useEffect(() => {
    const handleKeyPress = (e) => {
      if (e.key.toLowerCase() === "c") {
        combinedClick();
      }
      if (e.key.toLowerCase() === "s") {
        separateClick();
      }
    };
    window.addEventListener("keydown", handleKeyPress);
    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, [combinedClick, openShippingModal2, separateClick]);

  return (
    <div
      className={styles.order_modal}
      style={{ backgroundColor: mode && "#232529" }}
    >
      <div className={styles.modal_header}>
        <p style={{ color: mode && "#FFFFFF" }}>Choose Shipping</p>
        <div onClick={handleCloseModal}>
          <CloseIcon mode={mode} />
        </div>
      </div>

      <img
        src="/assets/updatedAssets/shippingCharge.png"
        alt="Shipping charges"
      />

      <p className={styles.main_txt} style={{ color: mode && "#FFFFFF" }}>
        Order has multiple warehouse items. <br /> Choose Shipping Type!
      </p>

      <div className={styles.bottom_buttons}>
        <div style={{ width: "30%" }}>
          <Button
            buttonBgColor={"#4164E3"}
            buttonTextColor={"#FFFFFF"}
            buttonText={"Combined"}
            buttonClick={combinedClick}
          />
          <p style={{ color: mode && "#FFFFFF" }} className={styles.btn_text}>
            Press - C
          </p>
        </div>

        <div style={{ width: "30%" }}>
          <Button
            buttonText={"Separate"}
            buttonBgColor={"#000000"}
            buttonTextColor={"#ffffff"}
            buttonClick={separateClick}
          />
          <p style={{ color: mode && "#FFFFFF" }} className={styles.btn_text}>
            Press - S
          </p>
        </div>
      </div>
    </div>
  );
};

export default ShippingTypeModal;
